import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rootReqContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    marginTop: theme.spacing(-4.75),
    marginBottom: theme.spacing(-1.75),
  },
  orderedList: {
    paddingLeft: theme.spacing(2),
  },
  contentText: {
    fontSize: '14px !important',
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
    marginRight: theme.spacing(0.5),
    '& > :not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  footerWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    alignItems: 'center',
  },
  requirementsMarginBottom: {
    marginBottom: theme.spacing(4),
  },
  marginBottom: {
    marginBottom: theme.spacing(15.5),
  },
}))
